import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import {Col, Row, Container} from 'reactstrap';
import {submitSearching, changeHandler} from './LawClassActionBlockSlice';
import TextInput from '../../Shared/TextInput/TextInput';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import LocalLoader from '../../Shared/LocalLoader/LocalLoader';
import {getRecaptchaToken} from './../../../utilities/recaptcha/recaptcha';

const LawClassActionSearchComponent = (props) => {
  const searchType = props.contentData.searchType?.value == '0' ? 'id' : 'phone';
  const submitSearching = async () => {
    if (!props.data.form.errors.id && !props.data.form.errors.phone && props.contentData?.lawClassActionCode?.value) {
      const token = await getRecaptchaToken('lawClass');

      if (token) {
        // send to server
        const searchRequest = {
          captchaToken: token,
          customer_id_number: props.data.form.id || '',
          customer_phone: props.data.form.phone || '',
          searchType: parseInt(props.contentData.searchType?.value),
          law_class_action_code: props.contentData?.lawClassActionCode?.value,
        };
        props.submitSearching(searchRequest);
      }
    }
  };
  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <Container className={`${isMobile ? 'pl-0 pr-0' : ''} law-class-action-search-block`}>
      <form noValidate id='law_class_action_form' onSubmit={handleSubmit}>
        <Col xs='12' sm='8' md='6' className='search_wrapper m-auto'>
          <Row>
            <Col className='text-center'>
              <h4>
                {props.contentData?.titleLawClass?.value}
                {searchType == 'id' ? 'תעודת זהות' : 'טלפון'} :
              </h4>
            </Col>
          </Row>
          <Row>
            {searchType == 'id' ? (
              <Col className='mt-2'>
                <TextInput
                  error={props.data.form.errors.id}
                  onChange={(e) => props.changeHandler({target: e.target, form: props.data.form})}
                  value={props.data.form.id}
                  name='id'
                  type='text'
                  placeholder='ת.ז'
                  required='required'
                />
              </Col>
            ) : (
              <Col className='mt-2'>
                <TextInput
                  error={props.data.form.errors.phone}
                  placeholder='טלפון'
                  id='phone'
                  name='phone'
                  maxLength='10'
                  type='number'
                  pattern='[0-9]*'
                  autoComplete='off'
                  value={props.data.form.phone}
                  onChange={(e) => props.changeHandler({target: e.target, form: props.data.form})}
                  required='required'
                />
              </Col>
            )}
          </Row>
          <Row>
            <Col className='mt-2'>
              {props.data.showResponse && (
                <>
                  {!props.data.showErrorMessage ? (
                    <>
                      {props.data.lawActionExists ? (
                        <p className='success-msg'>{props.contentData.searchLawClassFound?.value}</p>
                      ) : (
                        <p className='error-msg'>{props.contentData.searchLawClassNotFound?.value}</p>
                      )}
                    </>
                  ) : (
                    <p className='error-msg'>הבדיקה נכשלה</p>
                  )}
                </>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <BtnSubmit onclick={() => submitSearching()} text='לבדיקה'></BtnSubmit>
            </Col>
          </Row>
        </Col>

        {props.data.isShowLoader && <LocalLoader />}
      </form>
    </Container>
  );
};

const mapStateToProps = (state) => {  
  return {data: state.lawClassActionBlock};
};

const mapDispatchToProps = {
  submitSearching,
  changeHandler,
};

export default connect(mapStateToProps, mapDispatchToProps)(LawClassActionSearchComponent);
